import React, { useState } from 'react';
import { Alert, Spinner } from 'reactstrap';

import UweHubApi from '../api/UweHubApi';
import useResourceLoader from '../util/useResourceLoader';
import useTitle from '../util/useTitle';

// Verificar este slug contra el Worktray real configurado en el Hub antes de desplegar a un cliente.
const TICKETS_MODULE_ROUTE = 'help-desk-tickets';

export function Tickets() {
    useTitle('Tickets | JOLI');

    const [reloadCount, setReloadCount] = useState(0);

    const [embed, loading, error] = useResourceLoader(async () => {
        const isConfigured = await UweHubApi.isConfigured();
        if (!isConfigured) {
            return { configured: false };
        }

        const url = await UweHubApi.getModuleEmbedUrl({ moduleRoute: TICKETS_MODULE_ROUTE });
        return { configured: true, url };
    }, [reloadCount], null);

    if (loading || embed === null) {
        return <div className="d-flex justify-content-center p-5"><Spinner /></div>;
    }

    if (error) {
        return (
            <Alert color="danger" className="d-flex justify-content-between align-items-center">
                <span>No se pudo cargar el módulo de Tickets. {error.message}</span>
                <button className="btn btn-link" onClick={() => setReloadCount(c => c + 1)}>Reintentar</button>
            </Alert>
        );
    }

    if (!embed.configured) {
        return <Alert color="warning">Módulo de Tickets no configurado.</Alert>;
    }

    return (
        <iframe
            title="Tickets"
            src={embed.url}
            style={{ width: '100%', height: 'calc(100vh - 120px)', border: 'none' }}
        />
    );
}

export default Tickets;
